import { render, staticRenderFns } from "./HeaderOnePage.vue?vue&type=template&id=7130334c&scoped=true"
import script from "./HeaderOnePage.vue?vue&type=script&lang=js"
export * from "./HeaderOnePage.vue?vue&type=script&lang=js"
import style0 from "./HeaderOnePage.vue?vue&type=style&index=0&id=7130334c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7130334c",
  null
  
)

export default component.exports